import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import {CheckedOutRoomDetailsModal} from './Modal_DetailData_CheckedOutRoom';
import { CheckedOutRoomDetailsModal_multiple } from './Modal_DetailData_CheckedOutRoom_multiple';

//import classes from './Modal_ViewModal.module.css';
import '../../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewDepositsModal_Paid_In_Full (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [viewPaidInFull, setViewPaidInFull] = useState([]);

    let [invoiceID, setInvoiceID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);

    let [showInvoiceDetailsModal, setShowInvoiceDetailsModal] = useState(false);

    let [roomID, setRoomID] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [roomGuestInvoiceAttachment, setRoomGuestInvoiceAttachment] = useState(null);

    let [merchantInvoiceID, setMerchantInvoiceID] = useState(null);


    let [showCheckOutRoomDetailsModal, setUpdateCheckOutRoomDetailsModal] = useState(false);

    let [showCheckOutRoomDetailsModal_multiple, setUpdateCheckOutRoomDetailsModal_multiple] = useState(false);


    useEffect(() => {

            /*
            let formData = new FormData();
            formData.append('Tracker', '74002I_Paid_In_Full');
            formData.append('user', acctID);
            formData.append('xStartDateRange', props.startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', props.endDate.toISOString().substr(0, 10));
                

            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002I_Paid_In_Full',
                    user: acctID,
                    xStartDateRange: props.startDate.toISOString().substr(0, 10),
                    xEndDateRange: props.endDate.toISOString().substr(0, 10),
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    if(cols[7] == "booking" || cols[7] == "occupied")
                    {
                        setViewPaidInFull((prevViewPaidInFull) => {
                            return prevViewPaidInFull.concat({
                                roomID: cols[0],
                                roomSalePrice: null,
                                guestFirstName: cols[1],
                                guestLastName: cols[2],
                                guestPhoneNumber: cols[3],
                                dateCheckedInBooked: new Date(cols[4]).toISOString().substr(0, 10),
                                dateCheckedOutBooked: new Date(cols[5]).toISOString().substr(0, 10),
                                dateCheckedInActual: cols[6],
                                dateCheckedOutActual: cols[7],
                                merchantInvoiceID: cols[8],
                                room_id_multiple: cols[9],
                                totalAmountRecieved: parseFloat(cols[10]).toFixed(2),
                                invoiceAttachment: cols[11],
                            })
                        });
                    }
                    else
                    {
                        setViewPaidInFull((prevViewPaidInFull) => {
                            return prevViewPaidInFull.concat({
                                roomID: cols[0],
                                roomSalePrice: null,
                                guestFirstName: cols[1],
                                guestLastName: cols[2],
                                guestPhoneNumber: cols[3],
                                dateCheckedInBooked: new Date(cols[4]).toISOString().substr(0, 10),
                                dateCheckedOutBooked: new Date(cols[5]).toISOString().substr(0, 10),
                                dateCheckedInActual: cols[6],
                                dateCheckedOutActual: new Date(cols[7]).toISOString().substr(0, 10),
                                merchantInvoiceID: cols[8],
                                room_id_multiple: cols[9],
                                totalAmountRecieved: parseFloat(cols[10]).toFixed(2),
                                invoiceAttachment: cols[11],
                            })
                        });
                    }
                } 
            })
    }, []);

    function recreate_invoice_id(invoiceID)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', '74002IR');
        formData.append('user', acctID);
        formData.append('xInvoiceID', invoiceID);            

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74002IR',
                user: acctID,
                xInvoiceID: invoiceID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');
            let cols = rows[0].split('|');

            setRoomID("null");
            setRoomSalePrice("null");
            setRoomGuestInvoiceAttachment(cols[0]);
            alert("Invoice "+invoiceID+ " recreated.");
        })

    }

    function closeModalHandler(event) {

        //alert('Inside closeModalHandler');
        setViewPaidInFull([]);
        setUpdateCheckOutRoomDetailsModal(false);
        //props.closeModal(event);
    }
 
    function viewInvoiceDetailsHandler(event) {

        setInvoiceID(event[1]);
        setTotalAmount(event[2]);

        setShowInvoiceDetailsModal(event[0]);

    }
    function checkOutDetailModalHandler(event) {

        //alert('Inside Entern Check-In Handler');
        //alert(event[0]);
        //alert(event[1]);
        //alert(event[2]);

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        setMerchantInvoiceID(event[3]);
        setUpdateCheckOutRoomDetailsModal(event[0]);

    }

        function checkOutDetailModalHandler_multiple(event) {

        //alert('Inside Entern Check-In Handler Multiple');
        //alert(event[0]);
        //alert(event[1]);
        //alert(event[2]);
       //alert(event[3]);

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        setMerchantInvoiceID(event[3]);
        setUpdateCheckOutRoomDetailsModal_multiple(event[0]);

    }

    

    return (

        <React.Fragment> 

            <IonGrid className='appGridContent'>
                <IonRow >
                        <IonCol size='1'> <h3> Rm ID </h3> </IonCol>
                        <IonCol size='2'> <h3> First Name </h3> </IonCol>
                        {/*<IonCol size='3'> <h3> Check-In </h3> </IonCol>*/}
                        <IonCol size='3'> <h3> Check-Out </h3> </IonCol>
                        <IonCol size='3'> <h3> Total Amount </h3> </IonCol>                                       
                        <IonCol size='3'> <h3> Action </h3> </IonCol> 
                </IonRow>
            {viewPaidInFull.map((detailData) =>   {
                return (
                        <IonRow key={detailData.merchantInvoiceID}>
                            {detailData.room_id_multiple == 'NO' && <IonCol size='1'>{detailData.roomID}</IonCol>}
                            {detailData.room_id_multiple != 'NO' && <IonCol size='1'>{detailData.room_id_multiple}</IonCol>}
                            <IonCol size='2'>{detailData.guestFirstName}</IonCol>
                            {/*<IonCol size='3'>{detailData.dateCheckedInActual}</IonCol>*/}
                            <IonCol size='3'>{detailData.dateCheckedOutBooked}</IonCol>
                            <IonCol size='3'>{detailData.totalAmountRecieved}</IonCol>
                            {/*<IonCol size='3'>
                                <IonButton className='appListButton' onClick={() => recreate_invoice_id(detailData.merchantInvoiceID)}> Recreate Invoice </IonButton> 
                                <IonButton className='appListButton' onClick={() => setViewInvoiceModal(true)}> View Invoice </IonButton> 
                            </IonCol>*/}
                            <IonCol size='3'>
                                {(detailData.room_id_multiple == 'NO' && detailData.dateCheckedOutActual != 'booking' && detailData.dateCheckedOutActual != 'occupied') && <IonButton size='3' onClick={() => checkOutDetailModalHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.merchantInvoiceID])}> Details </IonButton>}
                                {(detailData.room_id_multiple != 'NO' && detailData.dateCheckedOutActual != 'booking' && detailData.dateCheckedOutActual != 'occupied') && <IonButton size='3' onClick={() => checkOutDetailModalHandler_multiple([true, detailData.room_id_multiple, detailData.roomSalePrice, detailData.merchantInvoiceID])}> M_Details </IonButton>}
                                {detailData.dateCheckedOutActual == 'occupied' && <IonText size='3'> Occupied </IonText>}
                                {detailData.dateCheckedOutActual == 'booking' && <IonText size='3'> Booking </IonText>}
                            </IonCol>
                        </IonRow>
                )
            }
            )}
            </IonGrid>

            {/*<ExpenseDetailsModal openModal={ showInvoiceDetailsModal } closeModal={() => setShowInvoiceDetailsModal(false)} data={{
                                invoiceID: invoiceID, 
                                totalAmount: totalAmount,
                                }}></ExpenseDetailsModal>*/}

            {showCheckOutRoomDetailsModal == true && <CheckedOutRoomDetailsModal openModal={ showCheckOutRoomDetailsModal } closeModal={() => setUpdateCheckOutRoomDetailsModal(false)} data={{
                    roomID: roomID, 
                    roomSalePrice: roomSalePrice,
                    merchantInvoiceID: merchantInvoiceID,
                                        }}></CheckedOutRoomDetailsModal>}

            {showCheckOutRoomDetailsModal_multiple == true && <CheckedOutRoomDetailsModal_multiple openModal={ showCheckOutRoomDetailsModal_multiple } closeModal={() => setUpdateCheckOutRoomDetailsModal_multiple()} data={{
                    roomID: roomID, 
                    roomSalePrice: roomSalePrice,
                    merchantInvoiceID: merchantInvoiceID,
                                        }}></CheckedOutRoomDetailsModal_multiple>}

            {/*<ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                            fileLocation: roomGuestInvoiceAttachment, 
                            roomID: roomID, 
                            roomSalePrice: roomSalePrice,
                            }}></ViewInvoiceModal>*/}
                    
        </React.Fragment>

    )
}